import { Button } from "antd";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { CountriesDropdown } from "shared-components/Components/Dropdowns/CountriesDropdown/web";
import { CountryCode } from "libphonenumber-js";
import CheckboxCustomInput from "shared-components/Components/CheckboxCustomInput";
import { handleFormBlur, isFormFilled } from "./utils/form";
import { WarningIcon } from "shared-components/Components/CustomIcons/WarningIcon/web";

const Modal = dynamic(
	(): any => import("shared-components/Components/Modal/web").then(mod => mod.Modal),
	{ ssr: false }
);

type Props = {
	open: boolean;
	onClose: () => void;
	property_id?: number | string;
	seller?: boolean;
	isProject?: boolean;
	formData?: {
		name: string;
		phone: string;
		email: string;
		fincatyc: boolean;
	};
	setFormData: (
		value: React.SetStateAction<{
			name: string;
			phone: string;
			email: string;
			fincatyc: boolean;
		}>
	) => void;
	onSubmit?: (e: MouseEvent) => Promise<void>;
	selectedCountryCode?: {
		code: CountryCode;
		value: string;
	};
	loading?: boolean;
	sentLead?: boolean;
	textButton?: string;
	setSelectedCountryCode?: (
		value: React.SetStateAction<{ code: CountryCode; value: string }>
	) => void;
};

export const ModalPhoneWithoutLogin = ({
	open,
	onClose,
	onSubmit,
	formData,
	setFormData,
	selectedCountryCode,
	setSelectedCountryCode,
	loading: isLoading,
	sentLead,
	textButton = "Enviar Consulta",
}: Props) => {
	const [errors, setErrors] = useState({
		name: false,
		phone: false,
		email: false,
		fincatyc: false,
	});
	const completedForm = isFormFilled(formData, selectedCountryCode);
	const isFincaraizColombia = process.env.APP_THEME === "fincaraiz";

	const renderWarningMessage = (message: string) => (
		isFincaraizColombia ? (
			<span className="error-message error-message--with-icon">
				<WarningIcon className="error-message-icon" />
				{message}
			</span>
		) : (
			<span className="error-message">{message}</span>
		)
	);

	const handleTYC = (e: React.ChangeEvent<HTMLInputElement>) => {
		setFormData({ ...formData, fincatyc: e.target.checked });
		setErrors({ ...errors, fincatyc: false });
	};

	const handleBlur = (
		e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
		fieldName: string
	) => {
		localStorage.setItem("contactForm", JSON.stringify(formData));
		localStorage.setItem("selectedCountryCode", JSON.stringify(selectedCountryCode));
		handleFormBlur(e, fieldName, {
			formData,
			selectedCountryCode,
			errors,
			setErrors,
		});
	};

	const handleCountryChange = value => {
		setSelectedCountryCode(value);
		handleBlur({ target: { value: formData?.phone } }, "phone");
	};

	return (
		<Modal show={open} title={textButton} onClose={onClose} width="540px">
			<>
				<form className="contact-form" style={{ textAlign: "left" }}>
					<div className="container-input">
						<input
							className={"contact-form-input " + (errors.name ? "error" : "")}
							name="nombre"
							placeholder="Nombre"
							value={formData?.name}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
								setFormData({ ...formData, name: e.target.value })
							}
							onBlur={e => handleBlur(e, "name")}
							required></input>
						{errors.name && <span className="error-message">Nombre no válido</span>}
					</div>

					<div className="row">
						<div className="container-input" style={{ width: "auto" }}>
							<CountriesDropdown
								onChange={handleCountryChange}
								countryCode={selectedCountryCode}
							/>
						</div>
						<div className="container-input" style={{ width: "100%" }}>
							<input
								className={"contact-form-input " + (errors.phone ? "error" : "")}
								name="telefono"
								placeholder="Teléfono"
								value={formData?.phone}
								onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
									const phone = e?.target?.value?.replace(/\D/g, "");
									setFormData({
										...formData,
										phone,
									});
									handleBlur({ target: { value: phone } }, "phone");
								}}
								onBlur={e => handleBlur(e, "phone")}
								type="tel"
								required></input>
							{errors.phone && (
								<span className="error-message">Teléfono no válido</span>
							)}
						</div>
					</div>

					<div className="container-input">
						<input
							className={"contact-form-input " + (errors.email ? "error" : "")}
							name="email"
							type="email"
							placeholder="Email"
							value={formData?.email}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
								setFormData({ ...formData, email: e.target.value })
							}
							onBlur={e => handleBlur(e, "email")}
							required></input>
						{errors.email && <span className="error-message">Email no válido</span>}
					</div>
					<CheckboxCustomInput
						className="tycfinca"
						value="acceptTYC"
						name="acceptTYCWL"
						id="checkboxFincaTyCWL"
						onChange={handleTYC}
						hasError={!isFincaraizColombia && errors.fincatyc}>
						Aceptas nuestros{" "}
						<a href="/informacion#terminos-y-condiciones" target="_blank">
							Términos y condiciones
						</a>{" "}
						y{" "}
						<a href="/informacion#politicas-de-privacidad" target="_blank">
							Política de privacidad
						</a>
					</CheckboxCustomInput>
					{isFincaraizColombia && errors.fincatyc && renderWarningMessage("Obligatorio aceptar términos y condiciones")}
					<Button
						type="primary"
						loading={false}
						disabled={!isFormFilled(formData, selectedCountryCode)}
						style={{ opacity: !completedForm ? 0.5 : 1 }}
						className="btn-send-lead"
						onClick={onSubmit}>
						{isLoading ? "Enviando" : textButton}
					</Button>
				</form>
			</>
		</Modal>
	);
};
